// groupLabel names a group among a member's groups: its name alone, adding
// who created it when another of them has the same name (spec 001 FR-039).
// A display name may be a full name, so only its first word is used.
import { t } from '../i18n/index.ts';

export function groupLabel(g: { id: string; name: string; created_by_name?: string }, all: { id: string; name: string }[]): string {
  const twin = all.some((o) => o.id !== g.id && o.name.toLowerCase() === g.name.toLowerCase());
  const who = (g.created_by_name ?? '').trim().split(/\s+/)[0];
  return twin && who ? t('groupsLabelCreator', { group: g.name, creator: who }) : g.name;
}
